import { useQuery } from "@tanstack/react-query";
import { dropinApi } from "@bw/shared/api";
import type { DropInPaymentOption } from "@bw/shared/types";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The player's drop-in payment options for a facility
 * (GET /facilities/{id}/drop-in/payment-options).
 *
 * Returns ONLY what this player can actually pay with — today the backend
 * populates `single_price` + `has_active_session` and leaves `active_packages`
 * / `active_memberships` empty, so the UI renders only the single drop-in fee
 * and hides membership/pass rows until the backend feeds them (no fabricated
 * options).
 */
export function useDropInPaymentOptions(
  facilityId: string,
  enabled: boolean = true,
) {
  return useQuery<DropInPaymentOption>({
    queryKey: queryKeys.dropin.paymentOptions(facilityId),
    queryFn: () => dropinApi.getPaymentOptions(facilityId),
    enabled: Boolean(facilityId) && enabled,
  });
}
